import React, { useMemo, useState, useEffect } from "react";

import axios from "axios";
import MaterialReactTable from "material-react-table";

const MortalidadInforme = ({ id }) => {
  const [list1, setList1] = useState([]);

  const columns = useMemo(
    () => [
      { accessorKey: "id", header: "Id", filterVariant: "text" },
      { accessorKey: "grupo", header: "Grupo", filterVariant: "text" },
      {
        accessorKey: "ano",
        header: "Año",
        filterVariant: "range",
        filterFn: "betweenInclusive",
      },
      {
        accessorKey: "consecutivo",
        header: "Consecutivo",
        filterVariant: "text",
      },
      { accessorKey: "causa", header: "Causa", filterVariant: "text" },
      { accessorKey: "estado", header: "Estado", filterVariant: "text" },
      {
        accessorKey: "datoMasculino",
        header: "Dato Masculino",
        filterVariant: "text",
      },
      {
        accessorKey: "proporcionMasculino",
        header: "Proporción Masculino",
        filterVariant: "text",
      },
      {
        accessorKey: "datoFemenino",
        header: "Dato Femenino",
        filterVariant: "text",
      },
      {
        accessorKey: "proporcionFemenino",
        header: "Proporción Femenino",
        filterVariant: "text",
      },
      { accessorKey: "total", header: "Total", filterVariant: "text" },
      {
        accessorKey: "proporcionTotal",
        header: "Proporción Total",
        filterVariant: "text",
      },
      {
        accessorKey: "nombreInstitucion",
        header: "Nombre Institución",
        filterVariant: "text",
      },
    ],
    [],
  );

  useEffect(() => {
    if (!id) return; // Evita la petición si no hay un ID válido

    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://suadesarrollo.azurewebsites.net/api/ObtenerQIndicadoresMortalidadPorInstitucionIdAno?InstitucionId=${id}&Ano=${new Date().getFullYear()}`,
          {
            auth: {
              username: "BasicAuth@icontec.org",
              password: "yQLzqmR7eZSuAmQZUqhY",
            },
          },
        );
        setList1(response.data);
      } catch (error) {
        console.error("Error al obtener los datos:", error);
      }
    };

    fetchData();
  }, [id]); // Dependencia corregida

  return (
    <div>
      <MaterialReactTable
        columns={columns}
        data={list1}
        initialState={{ showColumnFilters: true, density: "compact" }}
        muiTableBodyCellProps={{
          style: { padding: "4px", fontSize: "12px" }, // Reduce padding y tamaño de fuente
        }}
        muiTableHeadCellProps={{
          style: { padding: "4px", fontSize: "13px" }, // Reduce padding y tamaño de fuente en encabezados
        }}
        enableColumnResizing={false} // Evita que las columnas se expandan
        layoutMode="grid" // Reduce el espacio extra en la tabla
      />
    </div>
  );
};

export default MortalidadInforme;
